import { render, staticRenderFns } from "./changelog-duplicate.vue?vue&type=template&id=55bbfa3d"
import script from "./changelog-duplicate.vue?vue&type=script&lang=js"
export * from "./changelog-duplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports